import { useState, useRef } from 'react';
import { original, rose, vaporwave, matrix } from 'react95/dist/themes';
import { BrowserRouter, Router, Routes, Route, Link, useNavigate} from "react-router-dom";
import { createGlobalStyle, ThemeProvider, createTheme} from 'styled-components';
import { usePageSwipe } from '../../Hooks/UsePageSwipe';
import { usePageEnter } from '../../Hooks/UsePageEnter';
import { Highlight1 } from '../../App';
import {
    AppBar,
  Button,
  MenuList,
  MenuListItem,
  ScrollView,
  Separator,
  Toolbar,
    Frame,
  Window,
    Handle,
    
  WindowContent,
  WindowHeader,
    TextInput,
    styleReset
} from 'react95';



const AboutPage = () => {
    const imgBox = useRef(null);
    const descBox = useRef(null);
    console.log(Highlight1)
    
    const { transitionTo } = usePageSwipe('/Backpage', Highlight1);  // swipe up → AboutPage
    usePageEnter();

    
    
    const loadContent = (desc) => {
        descBox.current.innerHtml = desc;
    }
    
    
    const navigate = useNavigate();
    
    const handleRedirect = (dir) => {
        navigate(dir);
    };
    
    
    return (
            <ThemeProvider theme={rose}>
            <Window resizable className='window' style={{ display: 'block', height: '80vh', width: 'calc(90vh * (3/2))', maxWidth: "1200px"}}>
              <WindowHeader className='window-title' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span>Highlight: Glorgo's Microplastic Mine</span>
                <Button style={{ marginRight: '2px', width: '20px', height: '20px', padding: 0 }} onClick={() => handleRedirect('/')}>
                  <span style={{ fontWeight: 'bold', fontSize: '12px' }}>✕</span>
                </Button>
              </WindowHeader>

              <WindowContent style={{ height: 'calc(100% - 33px)', padding: 0, overflowX: 'auto', overflowY: 'hidden' }}>
                <Frame variant='well' className='footer' style={{ height: '100%', margin: 0, overflowX: 'auto', overflowY: 'hidden'}}>
                  
                <div style={{ 
                  height: '100%', 
                  overflowX: 'auto', 
                  overflowY: 'hidden',
                  display: 'flex',
                  flexDirection: 'row'
                }}>
                    <div style={{ display: 'inline-flex', flexDirection: 'row', height: '100%' }}>

                      {/* FIRST BOX — 1/3 width */}
                      <div style={{ display: 'flex', flexDirection: 'column', width: '400px', flexShrink: 0, height: '100%', borderRight: '2px solid #888' }}>
                        <div style={{ flex: 1, overflow: 'hidden' }}>
                          <img src='https://shared.fastly.steamstatic.com/store_item_assets/steam/apps/4246790/bd51796630c7bcc862e94a810fc7d782abc7879b/header.jpg?t=1780466183'
                            style={{ width: '100%', height: '40%', objectFit: 'cover', display: 'block' }}/>
                          <div style={{ padding: '8px', background: '#ab5a71', borderTop: '1px solid #888' }}>
                            <h1 style={{ color: "#ffffff", margin: 0, fontSize: '1rem' }}>Glorgo's Microplastic Mine</h1>
                            <h3 style={{ margin: 0, fontSize: '.8rem' }}>(2026)</h3>
                            <h2 style={{ margin: 0, fontSize: '.85rem' }}>3D Artist: Blender, Maya</h2>
                          </div>
                          <p style={{ whiteSpace: 'normal', fontSize: '.85em', padding: '8px', margin: 0, overflowY: 'auto', height: 'calc(60% - 80px)' }}>
                            Glorgo's Microplastics Mine is a 2.5D Sidescroller Incremental Game developed and published by USC Games as part of the 2026 cohort of Advanced Game Projects (AGP) Senior Capstone Projects. You play as a middle manager of a microplastics mine being bossed around by Glorgo, who demands increasingly more microplastics. The best way I could describe this game is Cookie Clicker meets Lemmings.
                          </p>
                        </div>
                      </div>

                      {/* SECOND BOX — 1/3 width */}
                      <div style={{ display: 'flex', flexDirection: 'column', width: '400px', flexShrink: 0, height: '100%', borderRight: '2px solid #888' }}>
                        <div style={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                          <p style={{ whiteSpace: 'normal', fontSize: '.85em', padding: '8px', margin: 0, flex: 1, overflowY: 'auto' }}>
                            I joined this game in January of 2026, somewhat late in development. Brought in by art lead Felicia Le as a 3D prop modeler after knowing my expertise from working on a friend's project. I ended up slotting pretty neatly into the development environment. I actually didn't really know what the game was about until I played it at its release at the USC Games Expo — I was so far removed from key design decisions, more preoccupied with following the descriptions handed down by my lead. For all I knew I could've been making models for a bomb. That was how good the direction was.
                          </p>
                          <div style={{ flexShrink: 0 }}>
                            <img src='https://shared.fastly.steamstatic.com/store_item_assets/steam/apps/4246790/41279fe59c896daaccfb0fcbafcb8396dc47cf40/ss_41279fe59c896daaccfb0fcbafcb8396dc47cf40.1920x1080.jpg?t=1780466183'
                              style={{ width: '100%', height: '250px', objectFit: 'cover', display: 'block' }}/>
                            <div style={{ padding: '6px 8px', background: '#ab5a71', borderTop: '1px solid #888' }}>
                              <p style={{ margin: 0, fontSize: '.8em', color: "#ffffff" }}>In-game screenshot</p>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* THIRD BOX — wider, 2 images top / 3 images bottom */}
                      <div style={{ display: 'flex', flexDirection: 'column', width: '600px', flexShrink: 0, height: '100%' }}>
                        
                        {/* Top row — 2 images */}
                        <div style={{ display: 'flex', flexDirection: 'row', flex: 1, borderBottom: '2px solid #888', overflow: 'hidden' }}>
                          
                          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', borderRight: '1px solid #888', overflow: 'hidden' }}>
                            <img src='/images/works/3DArt/Glorgos/microplastics.png'
                              style={{ width: '100%', flex: 1, objectFit: 'cover', display: 'block', minHeight: 0 }}/>
                            <div style={{ padding: '4px 8px', background: '#ab5a71', borderTop: '1px solid #888', flexShrink: 0 }}>
                              <p style={{ margin: 0, fontSize: '.8em', color: "#ffffff" }}>Microplastics prop</p>
                            </div>
                          </div>

                          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                            <img src='/images/works/3DArt/Glorgos/teef.png'
                              style={{ width: '100%', flex: 1, objectFit: 'cover', display: 'block', minHeight: 0 }}/>
                            <div style={{ padding: '4px 8px', background: '#ab5a71', borderTop: '1px solid #888', flexShrink: 0 }}>
                              <p style={{ margin: 0, fontSize: '.8em', color: "#ffffff" }}>Teef prop</p>
                            </div>
                          </div>

                        </div>

                        {/* Bottom row — 3 images */}
                        <div style={{ display: 'flex', flexDirection: 'row', flex: 1, overflow: 'hidden' }}>

                          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', borderRight: '1px solid #888', overflow: 'hidden' }}>
                            <img src='/images/works/3DArt/Glorgos/elevator1.png'
                              style={{ width: '100%', flex: 1, objectFit: 'cover', display: 'block', minHeight: 0 }}/>
                            <div style={{ padding: '4px 8px', background: '#ab5a71', borderTop: '1px solid #888', flexShrink: 0 }}>
                              <p style={{ margin: 0, fontSize: '.8em', color: "#ffffff" }}>Elevator Model that was later replaced by the hamster tube model that I also made</p>
                            </div>
                          </div>

                          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', borderRight: '1px solid #888', overflow: 'hidden' }}>
                            <img src='/images/works/3DArt/Glorgos/WindupToy.png'
                              style={{ width: '100%', flex: 1, objectFit: 'cover', display: 'block', minHeight: 0 }}/>
                            <div style={{ padding: '4px 8px', background: '#ab5a71', borderTop: '1px solid #888', flexShrink: 0 }}>
                              <p style={{ margin: 0, fontSize: '.8em', color: "#ffffff" }}>Windup Toy prop</p>
                            </div>
                          </div>

                          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                            <img src='/images/works/3DArt/Glorgos/GumballHead.png'
                              style={{ width: '100%', flex: 1, objectFit: 'cover', display: 'block', minHeight: 0 }}/>
                            <div style={{ padding: '4px 8px', background: '#ab5a71', borderTop: '1px solid #888', flexShrink: 0 }}>
                              <p style={{ margin: 0, fontSize: '.8em', color: "#ffffff" }}>Gumball Head prop</p>
                            </div>
                          </div>

                        </div>

                      </div>

                    </div>
                  </div>

                </Frame>
              </WindowContent>
            </Window>
          
          
    </ThemeProvider>
  );
}

export default AboutPage;
